import Vue from 'vue'
import animated from 'animate.css'

Vue.use(animated)



// WEBPACK FOOTER //
// ./src/plugins/animate.js